import { render, staticRenderFns } from "./type-table.vue?vue&type=template&id=1f63f230&scoped=true&"
import script from "./type-table.vue?vue&type=script&lang=js&"
export * from "./type-table.vue?vue&type=script&lang=js&"
import style0 from "./type-table.vue?vue&type=style&index=0&id=1f63f230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f63f230",
  null
  
)

export default component.exports